export enum RepositoryTabs {
  DATA = 'Data',
  COLLABORATORS = 'Collaborators',
}

export enum ShareScope {
  WHOLE_REPO = 'whole-repo',
  SELECTED_ACCOUNTS = 'selected-accounts',
}
